// Sidebar.tsx
import { NavLink } from "react-router-dom";
import Logo from "@/assets/TalykoLogo.png";
import {
  Newspaper,
  ScrollText,
  Settings,
  SquareStack,
  UserCog,
  Users,
} from "lucide-react";

export function Sidebar() {
  return (
    <div className="flex h-full w-56 flex-col items-center justify-between bg-[#A2D8D8AD] py-10 text-black">
      <img className="h-12" src={Logo} alt="talyko-Logo" />
      <div className="mt-10 flex w-full flex-1 flex-col items-center gap-y-5 px-5">
        {/* Fixed width and centralized NavLink components */}
        <NavLink
          to="/dashboard"
          className={({ isActive }) =>
            `flex w-full items-center justify-center gap-3 rounded-lg border px-10 py-2 text-center font-bold ${
              isActive
                ? "border border-black bg-yellow-300"
                : "border border-transparent"
            } hover:border-black hover:bg-yellow-300`
          }
        >
          <SquareStack className="h-6 w-6 flex-shrink-0" /> Dashboard
        </NavLink>

        <NavLink
          to="/invoices"
          className={({ isActive }) =>
            `flex w-full items-center justify-center gap-3 rounded-lg border px-10 py-2 text-center font-bold ${
              isActive
                ? "border border-black bg-yellow-300"
                : "border border-transparent"
            } hover:border-black hover:bg-yellow-300`
          }
        >
          <ScrollText className="h-6 w-6 flex-shrink-0" /> Invoices
        </NavLink>

        <NavLink
          to="/buildings"
          className={({ isActive }) =>
            `flex w-full items-center justify-center gap-3 rounded-lg border px-10 py-2 text-center font-bold ${
              isActive
                ? "border border-black bg-yellow-300"
                : "border border-transparent"
            } hover:border-black hover:bg-yellow-300`
          }
        >
          <Users className="h-6 w-6 flex-shrink-0" /> Customers
        </NavLink>

        <NavLink
          to="/expenses"
          className={({ isActive }) =>
            `flex w-full items-center justify-center gap-3 rounded-lg border px-10 py-2 text-center font-bold ${
              isActive
                ? "border border-black bg-yellow-300"
                : "border border-transparent"
            } hover:border-black hover:bg-yellow-300`
          }
        >
          <Newspaper className="h-6 w-6 flex-shrink-0" /> Expenses
        </NavLink>

        <NavLink
          to="/services"
          className={({ isActive }) =>
            `flex w-full items-center justify-center gap-3 rounded-lg border px-10 py-2 text-center font-bold ${
              isActive
                ? "border border-black bg-yellow-300"
                : "border border-transparent"
            } hover:border-black hover:bg-yellow-300`
          }
        >
          <Settings className="h-6 w-6 flex-shrink-0" /> Services
        </NavLink>

        <NavLink
          to="/account"
          className={({ isActive }) =>
            `flex w-full items-center justify-center gap-3 rounded-lg border px-10 py-2 text-center font-bold ${
              isActive
                ? "border border-black bg-yellow-300"
                : "border border-transparent"
            } hover:border-black hover:bg-yellow-300`
          }
        >
          <UserCog className="h-6 w-6 flex-shrink-0" /> Account
        </NavLink>
      </div>
      <div className="mt-10 flex items-center justify-center gap-3">
        <span className="text-xs">Terms of Service</span>
        <span className="text-xs">Privacy Policy</span>
      </div>
    </div>
  );
}
